module.exports = __webpack_public_path__ + "img/aa2a7ad.png";